import { Box, Flex, Grid, Text, VStack } from '@chakra-ui/react'

import type { PolicyVersionRiskItem } from '@/dtos/exceptionalDiscount'
import { AdjustmentChip } from '../components/AdjustmentChip'
import { DiffChip } from '../components/DiffChip'
import { fmtKc } from '../lib/premiumMath'
import { versionGridTemplate } from './versionGrid'

const PriceCell = ({ value, delta, muted }: {
  value?: number
  delta?: { amountKc: number, percent: number } | null
  muted?: boolean
}) => (
  <VStack alignItems="flex-end" spacing={1} px={4} py={2}>
    <Text fontWeight="bold" fontSize="md" color={muted ? 'gray.500' : 'gray.800'}>
      {value !== undefined && value !== null ? fmtKc(value) : '—'}
    </Text>
    {!muted && <DiffChip delta={delta} />}
  </VStack>
)

export const RizikoRow = ({ risk, muted }: { risk: PolicyVersionRiskItem, muted?: boolean }) => (
  <Grid templateColumns={versionGridTemplate} borderTopWidth="1px" borderColor="white" bg="gray.50">
    <Flex flexDirection="column" justifyContent="center" px={4} py={2} gap={1}>
      <Text fontSize="sm" color={muted ? 'gray.400' : 'gray.500'}>{risk.name ?? ''}</Text>
      {risk.adjustments.length > 0 && (
        <Box>
          {risk.adjustments.map((adjustment, i) => (
            <AdjustmentChip key={i} adjustment={adjustment} />
          ))}
        </Box>
      )}
    </Flex>
    <PriceCell value={risk.premiumFrequencyClient} delta={risk.periodClientDelta} muted={muted} />
    <PriceCell value={risk.annualPremiumClient} delta={risk.annualClientDelta} muted={muted} />
    <PriceCell value={risk.premiumFrequencyVwfs} delta={risk.periodVwfsDelta} muted={muted} />
    <PriceCell value={risk.annualPremiumVwfs} delta={risk.annualVwfsDelta} muted={muted} />
  </Grid>
)
